import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Head from 'next/head';
import Loader from '@meepshop/loader';
import { Container } from "../../components";
var Products = /*#__PURE__*/React.memo(function (props) {
  var loading = props.loading,
      page = props.page;
  if (loading) return /*#__PURE__*/React.createElement(Loader, {
    fullScreen: true
  });
  if (!page) return null;
  var _page$tabTitle = page.tabTitle,
      tabTitle = _page$tabTitle === void 0 ? '' : _page$tabTitle;

  var _ref = page.seo || {},
      keywords = _ref.keywords,
      description = _ref.description,
      image = _ref.image;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, null, !tabTitle ? null : /*#__PURE__*/React.createElement("title", null, tabTitle), !description ? null : /*#__PURE__*/React.createElement("meta", {
    key: "description",
    name: "description",
    content: description
  }), /*#__PURE__*/React.createElement("meta", {
    key: "keywords",
    name: "keywords",
    content: keywords
  }), !tabTitle ? null : /*#__PURE__*/React.createElement("meta", {
    key: "og:title",
    property: "og:title",
    content: tabTitle
  }), !image ? null : /*#__PURE__*/React.createElement("meta", {
    key: "og:image",
    property: "og:image",
    content: image
  }), !description ? null : /*#__PURE__*/React.createElement("meta", {
    key: "og:description",
    property: "og:description",
    content: description
  })), /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    page: page
  })));
});
Products.getInitialProps = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", {
            namespacesRequired: ['product-list']
          });

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));
export default Products;